import type { IxmUserauthV1RoleKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const USERAUTH_ROLE_BASE_PATH = getResolvedPath('/role');

export const getUserauthRolePath: EntityPathBuilder<IxmUserauthV1RoleKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return USERAUTH_ROLE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.roleId) {
        return undefined;
      }

      return getResolvedPath(`${USERAUTH_ROLE_BASE_PATH}/$roleId`, context.keys);
    }
  }
};

export function getUserauthRoleDetailPath(roleId: string | undefined) {
  if (!roleId) {
    return undefined;
  }

  return getUserauthRolePath({ kind: 'detail', keys: { roleId } });
}
